import Api from "@/services/api";
import {
    Folder,
    FolderDtoIn,
    MoveFolderDtoIn,
    MoveEntityDtoIn,
    FolderEntites,
    RootFolder,
    FolderOption
} from "@/services/folders/types";
import { FolderPost } from "@/services/posts/postTypes/folder";

export async function getFolderStructure(entity: FolderEntites): Promise<Folder> {
    return new Promise((resolve, reject) => {
        Api.get(`/folder/${entity}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function flatFolderStructure(entity: FolderEntites): Promise<Array<FolderOption>> {
    return new Promise((resolve, reject) => {
        getFolderStructure(entity).then(
            response => {
                const paths = [] as Array<FolderOption>;
                traverse(response, paths);
                resolve(paths);
            },
            error => {
                reject(error);
            }
        );
    });
}

function traverse(folder: Folder, paths: Array<FolderOption>) {
    paths.push({ id: folder.id, path: folder.path } as FolderOption);
    if (folder.children !== undefined && folder.children.length > 0) {
        folder.children.forEach(children => traverse(children, paths));
    }
}

export async function createOrUpdateFolder(
    model: FolderDtoIn
): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/folder", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function moveFolder(model: MoveFolderDtoIn): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/folder/move", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function moveEntity(model: MoveEntityDtoIn): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/folder/moveEntity", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/folder/delete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteFolder(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/folder/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFolderContent(
    id: string): Promise<FolderPost[]> {
    return new Promise((resolve, reject) => {
        Api.get(`/folder/content/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getRootFolder(
    entity: FolderEntites): Promise<RootFolder> {
    return new Promise((resolve, reject) => {
        Api.get(`/folder/${entity}/root`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
